import { Link } from "react-router-dom";
import { ShieldCheck, MonitorSmartphone, GlobeLock, Users, ArrowLeft } from "lucide-react";

export default function DeliverExams() {
    return (
        <main className="min-h-screen bg-gradient-to-b from-indigo-700 via-indigo-600 to-violet-600 px-6 py-12 flex justify-center">
            <div className="w-full max-w-5xl bg-white rounded-2xl shadow-xl p-8">
                <div className="flex items-center gap-3 mb-6">
                    <img src="/Images/ExamsPro.png" alt="ExamsPro" className="w-10 h-10" />
                    <h1 className="text-2xl font-bold text-indigo-700">Deliver Exams</h1>
                </div>

                <p className="text-gray-600 mb-8">
                    Lock down browsers, proctor sessions, and scale delivery to thousands of candidates—
                    in person or remote.
                </p>

                <section className="grid md:grid-cols-2 gap-6">
                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <ShieldCheck className="w-5 h-5" />
                            <h3 className="font-semibold">Secure Browser</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>• Disable copy/paste, screenshots, external tabs</li>
                            <li>• AI-plagiarism checks & question scrambling</li>
                            <li>• Device posture checks</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <MonitorSmartphone className="w-5 h-5" />
                            <h3 className="font-semibold">Remote Proctoring</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>• Live or record & review</li>
                            <li>• Multi-stream (screen, cam, mic) with flags</li>
                            <li>• Proctor chat & escalation</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <GlobeLock className="w-5 h-5" />
                            <h3 className="font-semibold">Access Policies</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>• Geofencing, device binding, IP ranges</li>
                            <li>• Time windows & late policies</li>
                            <li>• Multi-factor authentication (PIN/Face/Voice)</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Users className="w-5 h-5" />
                            <h3 className="font-semibold">Centers & Rooms</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>• Seat planning & proctor rosters</li>
                            <li>• Check-in workflows & ID validation</li>
                            <li>• Incident logging & chain of custody</li>
                        </ul>
                    </div>
                </section>

                {/* ✅ CTA Buttons */}
                <div className="mt-10 flex flex-wrap justify-center gap-4">
                    <Link
                        to="/support/contact"
                        className="inline-flex items-center justify-center bg-indigo-600 text-white px-5 py-2.5 rounded-full font-semibold hover:bg-indigo-700 transition shadow-sm"
                    >
                        Talk to Sales
                    </Link>

                    {/* 🧭 Back Button (styled for visibility) */}
                    <Link
                        to="/solutions/examspro"
                        className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 hover:text-indigo-800 px-5 py-2.5 rounded-full font-semibold transition shadow-sm"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Back to ExamsPro
                    </Link>

                </div>
            </div>
        </main>
    );
}
